import ContractForm from '@/components/contracts/ContractForm'
import { ContractFormValues, SharedProps, Zone } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Paper, Stack, Title } from '@mantine/core'

export default function NewContractPage({ current_organization, zones }: SharedProps & { zones: Zone[] }) {
  const handleCreateContract = (values: ContractFormValues) => {
    router.post(`/organizations/${current_organization!.slug}/contracts`, {
      contract: values,
    })
  }

  return (
    <>
      <Head title={`Nouveau contrat - ${current_organization?.name}`} />

      <Stack maw={600} mx="auto" w="100%">
        <Title>Nouveau contrat</Title>

        <Paper withBorder radius="md" p="md">
          <ContractForm onSubmit={handleCreateContract} submitLabel="Créer le contrat" showSmsNotification zones={zones} />
        </Paper>
      </Stack>
    </>
  )
}
